import toastify from '../lib/toastify';
import { UseMutationResult, useMutation, useQueryClient } from '@tanstack/react-query';
import { renewAdById } from '../services/Ad.service';
import { LISTING_QUERY, RENEW_MUTATION_QUERY } from '../queries';
import { useHistory } from 'react-router-dom';
import { MY_LISTINGS } from '../../utils/routes';
import { useListingFilterContext } from '../store/contexts/listingFilter';

interface UseRenewAd {
  renewMutation: UseMutationResult<void, unknown, void, unknown>;
}

export function useRenewAd(id: number): UseRenewAd {
  const queryClient = useQueryClient();
  const history = useHistory();
  const { setSelectedOption } = useListingFilterContext();

  const renewMutation = useMutation({
    mutationKey: [RENEW_MUTATION_QUERY, id],
    mutationFn: () => renewAdById(id),
    onSuccess() {
      toastify.success(`Anúncio ativado`, `seu anúncio foi ativado com sucesso `);
      queryClient.invalidateQueries([LISTING_QUERY]);
      setSelectedOption('all');
      history.push(MY_LISTINGS);
    },
    onError() {
      toastify.error(
        `Anúncio não publicado`,
        `Não foi possível publicar o seu anúncio. Tente de novo.`
      );
    }
  });

  return { renewMutation };
}
